import MainLayout from '../../../../commons/layout/MainLayout';
import VideoComponentCustom from '../../../../commons/components/Video';
import { useNavigate } from 'react-router-dom';
import ROUTERS from '../../../../commons/constans/router';
import { useEffect, useState } from 'react';
import VideoFormStatusComponent from './videoFormStatus';
import { useDispatch, useSelector } from 'react-redux';
import DialogPublishSuccess from './dialogPublishSuccess';
import { log } from '../../../../utils/helpers';
type Props = {
  handleClosePublic: Function,
  videoDetail: Object,
  videoEmoji: Array,
  deleteVideo: Function,
};
const VideoPlayerComponent = ({
  handleClosePublic,
  videoDetail,
  videoEmoji,
  deleteVideo
}: Props) => {
  const navigate = useNavigate();
  const [onClose, setOnclose] = useState(false);
  const [statusDialogUpdateSuccess, setStatusDialogUpdateSuccess] = useState(false);
  const {userInfo} = useSelector((state) => state.authReducers);
  const [isPlayVideo, setIsPlayVideo] = useState(true);
  const [isClickVideo, setIsClickVideo] = useState(false);
  

  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  };

  const onClosePublic = () => {
    setOnclose(true);
  };

  handleClosePublic = () => {
    setOnclose(false);
  };
  
  const closePopupStatus = () => {
    navigate(ROUTERS.VIDEO_DETAIL_PATH(videoDetail?.id), {state: {prevPath: 'prevPath'}})
  }

  const handleDialogConfirmUpdateStatus = (data) => {
    setStatusDialogUpdateSuccess(true);
  }

  const handleCloseUpdate = () => {
    setStatusDialogUpdateSuccess(false);
    navigate(ROUTERS.ALBUM);
  }

  const handleClick = () => {
    if (!isPlayVideo) {
      setIsClickVideo(!isClickVideo);
    }
  }

  useEffect(() => {
    if (isClickVideo) {
      document.getElementsByClassName('video-react-control-bar')[0].classList.add('d-none');
      document.getElementById('player-custom-video').classList.remove('background-video');
    }else{
      document.getElementsByClassName('video-react-control-bar')[0].classList.remove('d-none');
      document.getElementById('player-custom-video').classList.add('background-video');
    }
  }, [isClickVideo])

  const handlePlayStatus = (status) => {
    setIsPlayVideo(status);
    if (status) {
      document.getElementsByClassName('video-react-control-bar')[0].classList.remove('d-none');
      document.getElementById('player-custom-video').classList.add('background-video');
    }
  }

  return (
    <MainLayout
      pageID={'video-player-show'}
      handleLeftClick={() => handleLeftClick()}
      displayBottomNav={false}
    >
      <div className="wrapper" id='video-container' onClick={() => handleClick()}>
        <VideoComponentCustom
          onClosePublic={onClose}
          videoDetail={videoDetail}
          resetHandleClosePublic={handleClosePublic}
          deleteVideo={deleteVideo}
          userInfo={userInfo}
          handlePlayStatus={handlePlayStatus}
        />
        <div style={{zIndex: 9}}>
          <div className="album-video-detail-page__title">
            <div className="d-flex justify-content-between">
              <div className />
              <h4 className="album-video-detail-page__title-video-page ml-4">
                영상공개
              </h4>
              <img
                src="/images/album/icon_X_black_small.svg"
                className="album-video-detail-page__icon-delete"
                alt=""
                onClick={() => onClosePublic()}
              />
            </div>
          </div>
          <div className="album-video-detail-page__content">
            <p className="text-center p-0 m-0">아이들의 반응은 어땠나요?</p>
            <p className="text-center p-0 m-0">
              간단한 이용 후기와 함께 영상을 공개하면
            </p>
            <p className="text-center p-0 m-0">추첨을 통해 선물을 드립니다.</p>
          </div>
          <div className="album-video-detail-page__public">
            <VideoFormStatusComponent
              videoDetail={videoDetail}
              publishedBtn={true}
              videoEmoji={videoEmoji}
              closePopupStatus={closePopupStatus}
              handleDialogConfirmUpdateStatus={handleDialogConfirmUpdateStatus}
            />
          </div>
        </div>
        <DialogPublishSuccess 
        statusDialogUpdateSuccess={statusDialogUpdateSuccess}
        handleCloseUpdate={handleCloseUpdate}
        />
      </div>
    </MainLayout>
  );
};

export default VideoPlayerComponent;
